import { AxiosContext } from "contexts/AxiosContext";
import { IComment } from "interfaces/comment";
import { useContext, useState } from "react";

interface Result {
  loading: boolean;
  getComments: () => Promise<IComment[]>;
}

export function useReadComments(pathPrefix: string): Result {
  const { axios } = useContext(AxiosContext)!;
  const [loading, setLoading] = useState(false);

  const headers = {
    Accept: "application/json"
  };

  async function getComments(): Promise<IComment[]> {
    setLoading(true);
    const { data } = await axios.get<IComment[]>(
      `${pathPrefix}/comments?ordering=-create_date`,
      { headers }
    );
    setLoading(false);
    return data;
  }

  return {
    loading,
    getComments
  };
}
